import Vue from "vue";
import Router from "vue-router";
import store from "./store/index";

Vue.use(Router);

let gameType = '',
  gameAppkeyArr = ['', '1504685273578', '1705460260139', '1611630374326', '1656417299063', '1693534261653'];//游戏对应appkey
switch (true) {
  case location.href.indexOf('epic7-community.zlongame.com') != -1 || window.user.appkey == gameAppkeyArr[3]: gameType = '第七史诗'
    break;
  case location.href.indexOf('ma-community.tentree-games.com') != -1 || window.user.appkey == gameAppkeyArr[2]: gameType = '鋼嵐'
    break;
  case location.href.indexOf('lhlr-community.zlongame.com') != -1 || window.user.appkey == gameAppkeyArr[4]: gameType = '龙魂旅人'
    break;
  case location.href.indexOf('rox-community.zlongame.com') != -1 || window.user.appkey == gameAppkeyArr[5]: gameType = 'ROX'
    break;
  default: gameType = '龙之国物语'
    break;
}
//获取原型对象上的push函数
// const originalPush = Router.prototype.push
//修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const routes = [
  {
    path: "*",
    redirect: "./homePage",
  },

  //个人页面
  {
    name: "userPage",
    component: () => import("./components/userPage"),
    meta: {
      title: "我的",
      footShow: true,
      msgShow: false,
      keepAlive: true
    },
  },
  {
    name: "otherHome",
    component: () => import("./components/userPage/page/otherHome.vue"),
    meta: {
      title: "个人主页",
      footShow: false,
      msgShow: false,
      keepAlive: true
    },
  },
  {
    name: "personal",
    component: () => import("./components/userPage/page/personal"),
    meta: {
      title: "个人主页",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  // 首页
  {
    name: "homePage",
    component: () => import("./components/homePage"),
    meta: {
      title: gameType,
      footShow: true,
      msgShow: false,
      keepAlive: true
    },
  },
  // 热点话题页
  {
    name: "subjectPage",
    component: () => import("./components/homePage/page/hot/hot"),
    meta: {
      title: "热门话题",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  // 热点分区
  {
    name: "partitionPage",
    component: () => import("./components/homePage/page/hot/partition"),
    meta: {
      title: "版块",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  // 搜索页
  {
    name: "search",
    component: () => import("./components/homePage/page/search"),
    meta: {
      title: "搜索",
      footShow: false,
      msgShow: false,
      keepAlive: true
    },
  },
  // 搜索详情页
  {
    name: "searchResult",
    component: () => import("./components/homePage/page/searchResult"),
    meta: {
      title: "搜索详情",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  {
    name: "editData",
    component: () => import("./components/userPage/page/editData"),
    meta: {
      title: "编辑资料",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  {
    name: "wikiPage",
    component: () => import("./components/guidePage/wikiPage.vue"),
    meta: {
      title: gameType,
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  {
    name: "guidePage",
    component: () => import("./components/guidePage"),
    meta: {
      title: gameType,
      footShow: true,
      msgShow: false,
      keepAlive: true
    },
    children: [
      {
        path: 'gameintro',
        name: 'gameintro',
        component: () => import("./components/guidePage/glPage/gameIntro"),
        meta: {
          title: gameType,
          footShow: true,
          msgShow: false,
          keepAlive: true
        }
      },
      {
        path: 'gameinfo',
        name: 'gameInfoMainPage',
        component: () => import("./components/guidePage/glPage/gameInfo"),
        meta: {
          title: gameType,
          footShow: true,
          msgShow: false,
          keepAlive: true
        },
      },
      {
        path: 'detailPage',
        name: 'detailPage',
        component: () => import("./components/guidePage/glPage/gameIntro/page/detailPage.vue"),
        meta: {
          title: gameType,
          footShow: true,
          msgShow: false,
          keepAlive: true
        },
      },
      {
        name: 'glPainting',
        path: 'painting',
        component: () => import("./components/guidePage/glPage/gameIntro/page/painting.vue"),
        meta: {
          title: gameType,
          footShow: true,
          msgShow: false,
          keepAlive: true
        },
      },
      {
        path: 'dqssgameintro',
        name: 'dqssgameintro',
        component: () => import("./components/guidePage/dqssPage/gameIntro"),
        meta: {
          title: gameType,
          footShow: true,
          msgShow: false,
          keepAlive: true
        }
      },
      {
        path: 'dqssgameinfo',
        name: 'dqssgameInfoMainPage',
        component: () => import("./components/guidePage/dqssPage/gameInfo"),
        meta: {
          title: gameType,
          footShow: true,
          msgShow: false,
          keepAlive: true
        },
      },
    ]
  },
  {
    name: "postPage",
    component: () => import("./components/uploadPage"),
    meta: {
      title: gameType,
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  // 富文本發布
  {
    name: "rich",
    component: () => import("./components/uploadPage/rich.vue"),
    meta: {
      title: gameType,
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  {
    name: "rich2",
    component: () => import("./components/uploadPage/rich2.vue"),
    meta: {
      title: gameType,
      footShow: false,
      msgShow: false,
      keepAlive: false,
      leftShow: false
    },
  },
  {
    name: "topicPage",
    component: () => import("./components/detailsPage"),
    meta: {
      title: "帖子详情",
      footShow: false,
      msgShow: true,
      keepAlive: true
    },
  },
  {
    name: "listPage",
    component: () => import("./components/listPage"),
    meta: {
      title: "列表",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },

  //消息页面
  {
    name: "messagePage",
    component: () => import("./components/messagePage"),
    meta: {
      title: gameType,
      footShow: true,
      msgShow: false,
      keepAlive: true
    },
  },
  {
    name: "mesdetails",
    component: () => import("./components/messagePage/page/mesdetails.vue"),
    meta: {
      title: "消息详情",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  {
    name: "userSet",
    component: () => import("./components/userPage/page/userSet.vue"),
    meta: {
      title: "设置",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  {
    name: "noticeShow",
    component: () => import("./components/messagePage/page/noticeShow.vue"),
    meta: {
      title: "通知详情",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },
  {
    name: "postShare",
    component: () => import("./components/postShare"),
    meta: {
      title: "帖子详情",
      footShow: false,
      msgShow: false,
      keepAlive: false
    },
  },



  //登录页面
  {
    name: "xcxlogin",
    component: () => import("./components/login/xcxlogin/xcxlogin"),
    meta: {
      title: "龙之国物语社区",
      footShow: false,
      msgShow: false,
      keepAlive: false,
      leftShow: true
    },
  },
  //我的任务
  {
    name: "task",
    component: () => import("./components/task/index.vue"),
    meta: {
      title: "我的任务",
      footShow: false,
      msgShow: false,
      keepAlive: false,
      leftShow: false
    },
  },
  // 积分
  {
    name: "upGuide",
    component: () => import("./components/pointsPage/upGuide.vue"),
    meta: {
      title: "升级攻略",
      footShow: false,
      msgShow: false,
      keepAlive: false,
      leftShow: false
    },
  },
  {
    name: "pointList",
    component: () => import("./components/pointsPage/pointList.vue"),
    meta: {
      title: "积分",
      footShow: false,
      msgShow: false,
      keepAlive: true,
      leftShow: false
    },
  },
  {
    name: "exchangeCenter",
    component: () => import("./components/pointsPage/exchangeCenter.vue"),
    meta: {
      title: "兑换中心",
      footShow: false,
      msgShow: false,
      keepAlive: true,
      leftShow: false
    },
  },
  {
    name: "goodDetail",
    component: () => import("./components/pointsPage/goodDetail.vue"),
    meta: {
      title: "商品详情",
      footShow: false,
      msgShow: false,
      keepAlive: false,
      leftShow: false
    },
  },
  {
    name: "orderDetail",
    component: () => import("./components/orderPage/orderDetail.vue"),
    meta: {
      title: "订单详情",
      footShow: false,
      msgShow: false,
      keepAlive: false,
      leftShow: false
    },
  },
  {
    name: "orderConfirm",
    component: () => import("./components/orderPage/orderConfirm.vue"),
    meta: {
      title: "订单确认",
      footShow: false,
      msgShow: false,
      keepAlive: false,
      leftShow: false
    },
  },
];

// add route path
routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});
// let _this = this
const router = new Router({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export { router };
